export default {
  fields: {
    package_id: {
      readOnly: true,
    },
    category_id: {
      readOnly: true,
    },
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    }
  },
  relationships: {
    package: 'booking_packages',
    category: 'booking_package_categories',
  },
}
